<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<h3 *ngIf="!isInTab"
    [class.slds-theme_shade]="isMultipleSections"
    class="slds-section__title">
  <button (click)="onSectionClick($event)"
          *ngIf="isCollapsable"
          class="slds-button slds-section__title-action">
    <svg aria-hidden="true" class="slds-section__title-action-icon slds-button__icon slds-button__icon_left">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#switch"></use>
    </svg>
    {{ labelName }}
  </button>
  <span *ngIf="isNotCollabsable"
        class="slds-truncate slds-p-horizontal_small"
        [title]="labelName">{{ labelName }}</span>
</h3>

<section class="slds-section__content slds-grid slds-wrap">

  <acc-form-element *ngFor="let field of formFieldList"
                    [ff]="field"
                    [fm]="fm"
                    [record]="record"
                    class="slds-col slds-size_1-of-1 slds-small-size_1-of-2">
  </acc-form-element>

</section>
